import { AppModules } from 'appContainer/types';
import { param } from 'router/declarative/paramRegistry';
import { RouteNode } from 'router/declarative/routeNode';

export const SURVEY_ADMIN_ROUTE = '/survey-admin';

const stringParam = param({
  fromString: value => value,
  toString: value => value,
});

export const routes = {
  path: SURVEY_ADMIN_ROUTE,
  appModule: AppModules.SURVEY_ADMIN,
  searchParams: {
    surveyId: stringParam,
    token: stringParam,
    ref: stringParam,
    type: stringParam,
  },
  content: async () =>
    (await import('../SurveyAdminRoutePage')).SurveyAdminRoutePage,
  children: [
    {
      path: { index: true },
      title: 'Surveys',
    },
    {
      path: '/new',
      title: 'New Survey',
      searchParams: { surveyFolderId: stringParam },
    },
    {
      path: '/edit',
      children: [
        {
          path: '/:surveyId',
          title: 'Edit Survey',
        },
      ],
    },
    {
      path: '/response-approval',
      children: [
        {
          path: '/:surveyId',
          title: 'Response Approval',
        },
      ],
    },
  ],
} as const satisfies RouteNode;
